import { setLogLevel } from 'livekit-client';

import { getLogLevel } from '../logger.js';

/**
 * Quiet livekit-client's console output.
 *
 * livekit-client defaults to `LogLevel.info`, which prints verbose connection
 * details to the browser console — including the room-join token in the signal
 * URL (`signal connecting to wss://…?access_token=…`), connection-state
 * transitions, participant objects, and `publishing track`. None of that
 * belongs in a production console.
 *
 * We map our resolved app log level (see `core/logger.ts` for the precedence
 * chain) onto livekit's logger so it stays at `warn` (errors/warnings only)
 * unless someone explicitly asks for debug output. Idempotent and safe to call
 * from every livekit entry point (iframe app + SDK).
 */
export function configureLivekitLogging(): void {
  const appLevel = getLogLevel();
  const livekitLevel = appLevel === 'debug' ? 'debug' : appLevel === 'error' ? 'error' : 'warn';
  setLogLevel(livekitLevel);
}
